import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { NumberCircle } from '@naf-simba/elements-numbers';
import { Text } from '@naf/text';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
`;

export const ListItem = styled.div`
  display: grid;
  grid-template-columns: ${spacing.space24} auto;
  gap: ${spacing.space16};

  & p,
  figure,
  h4 {
    margin: 0;
  }

  padding-top: ${spacing.space16};
  padding-bottom: ${spacing.space16};
  border-top: 1px solid ${({ theme }) => theme.border.subtle || themeLight.border.subtle};
`;

export const HeaderText = styled(Text)`
  grid-row: 1;
  grid-column: 2;
`;

export const ContentWrapper = styled.div`
  grid-column: 2/ -1;
`;

export const StyledNumber = styled(NumberCircle)`
  grid-row: 1;
  grid-column: 1;
  align-self: center;
`;
